import { FormProvider } from 'react-hook-form';
import { useMutation, useQueryClient } from 'react-query';
import { Button, HStack, Stack } from '@chakra-ui/react';

import { API, APIRoutes } from 'api';
import notify from 'utils/notify';
import { useFormWithSchema } from 'utils/formHooks';
import Input from 'components/Form/Input';
import {
  BODY_SCHEMA,
  DEFAULT_VALUES,
  FormValues,
} from 'pages/SubscriptionUsers/Listing/components/AssignCouponModal/constants';

type AssignCouponFormProps = {
  userId: string;
  onClose: () => void;
};

function AssignCouponForm({ userId, onClose }: AssignCouponFormProps) {
  const queryClient = useQueryClient();

  const { mutate: assignCoupon, isLoading } = useMutation({
    mutationKey: 'assignCoupon',
    mutationFn: (data: FormValues) =>
      API.post(APIRoutes.subscriptionCoupons.directlyAssign, {
        ...data,
        userId,
      }),
    onSuccess: () => {
      onClose();
      notify('success', 'Kupon został przypisany');
      queryClient.invalidateQueries('subscriptionCoupons');
    },
    onError: () => {
      notify('error', 'Wystąpił problem podczas przypisywania kuponu');
    },
  });

  const methods = useFormWithSchema(BODY_SCHEMA, {
    mode: 'onChange',
    defaultValues: DEFAULT_VALUES,
  });

  const { handleSubmit } = methods;

  const onSubmit = handleSubmit(async (data) => assignCoupon(data));

  return (
    <FormProvider {...methods}>
      <form onSubmit={onSubmit}>
        <Stack spacing={6}>
          <Stack spacing={4}>
            <Input name="value" label="Wartość" type="number" />
          </Stack>
          <HStack spacing={2} justify="center">
            <Button variant="link" onClick={onClose}>
              Anuluj
            </Button>
            <Button variant="solid" isLoading={isLoading} type="submit">
              Zapisz i wróć
            </Button>
          </HStack>
        </Stack>
      </form>
    </FormProvider>
  );
}

export default AssignCouponForm;
